module.exports = __webpack_public_path__ + "img/logo.1de2c45f.png";